const DEFAULT_OBSERVED_WIDTH = 800;

export class WidthObserver {
    // A single ResizeObserver to watch all tagged elements
    static observer = (typeof (ResizeObserver) === "undefined") ? null : new ResizeObserver(entries => {
        for (const entry of entries) {
            const observeWidth = parseInt(entry.target.dataset.observeWidth, 10) || DEFAULT_OBSERVED_WIDTH;
            // Set the 'data-observe-wider' attribute to 'true' or 'false'
            entry.target.setAttribute("data-observe-wider", entry.contentRect.width > observeWidth);
            entry.target.style.setProperty("--observed-width", `${Math.floor(entry.contentRect.width)}px`);
        }
    });

    /** Iterate through each element with a 'data-observe-width' attribute and watch for resizes. Elements already being observed won't be duplicated. */
    static PerformWireup() {
        if (this.observer) {
            const elementsToObserve = document.querySelectorAll("[data-observe-width]");
            for (const element of elementsToObserve) {
                this.observer.observe(element);
            }
        }
    }
}
